export default __webpack_public_path__ + "4b493aa2dd6a7ef27921ac67a24f76c0.ttf";